import AmbassadorProfile from './AmbassadorProfile';
export default AmbassadorProfile;
